import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const rootEl = document.getElementById("root");
const root = ReactDOM.createRoot(rootEl);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// iter97 · Anti-FOUC flag. SSG writes a static prerender preview
// inside #root (via `scripts/ssg-postbuild.js`); React mount then
// replaces it. The `data-hydrated="false"` attribute lets CSS hide
// the prerender preview during the ~100-300 ms before mount
// completes, so humans never see the duplicated text flash.
// Crawlers scrape the raw HTML with the preview visible — they
// don't execute this flip.
if (typeof queueMicrotask === "function") {
  queueMicrotask(() => {
    try { rootEl.setAttribute("data-hydrated", "true"); } catch (_) {}
  });
} else {
  setTimeout(() => rootEl.setAttribute("data-hydrated", "true"), 0);
}
